import { Field, Form, Formik } from "formik";
import AdminFormLayout from "../../components/common/form-layout/AdminFormLayout";
import {
  errorMessage,
  successMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import { postApi, putApi } from "../../services/api/globalApi";
import Input from "../../components/common/inputs/Input";
import Button from "../../components/common/button/Button";
import { useEffect, useRef, useState } from "react";
import { categoryValidation } from "../../utils/validation/categoryValidation";
import { useLocation, useNavigate } from "react-router";
import VendorCategoriesSelect from "../../components/common/inputs/VendorCategoriesSelect";
import Select from "../../components/common/inputs/Select";
import { publicImageProps } from "../../services/config";
import ImagesModal from "../../components/common/modals/imgaes-modal/ImagesModal";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";

export default function VendorStoreCategory() {
  const location = useLocation();
  const navigate = useNavigate();

  const { utils } = useSelector(utilsState);

  const [parents, setParents] = useState([]);

  const formHandler = async (values, { resetForm }) => {
    console.log(values);
    const body = {
      ...values,
      parents,
      showInHomePage: values.showInHomePage == "true" ? true : false,
      isMain: values.isMain == "true" ? true : false,
      image: image,
    };
    try {
      if (location.state) {
        await putApi({
          path: `admin/vendorStoreProductCategories/${location.state?.id}`,
          body: JSON.stringify(body),
        });
        successMessage("دسته بندی با موفقیت ویرایش شد");
      } else {
        await postApi({
          path: "admin/vendorStoreProductCategories",
          body: JSON.stringify(body),
        });
        successMessage("دسته بندی با موفقیت اضافه شد");
      }
      resetForm();
      navigate("/vendor-store-category-list");
      categoryRef.current.afterSubmit();
    } catch (error) {
      console.error(error);
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };

  const categoryRef = useRef();

  useEffect(() => {
    if (location.pathname == "/add-vendor-store-category") {
      categoryRef.current.afterSubmit();
    }
  }, [location.pathname]);

  useEffect(() => {
    if (location?.state?.image) {
      setImage(location.state.image);
    }
  }, [location.state]);

  const imagesModal = useRef();
  const [image, setImage] = useState("");

  const selectedImages = (item) => {
    console.log(item);
    if (item) {
      setImage(item.name);
      successMessage("عکس اضافه شد.");
    }
  };

  return (
    <AdminFormLayout title={location?.state ? "ویرایش دسته‌بندی غرفه" : "افزودن دسته‌بندی غرفه"} description="نام، تصویر و محل نمایش دسته‌بندی محصولات غرفه را تنظیم کنید.">

      <Formik
        enableReinitialize
        initialValues={{
          name: location?.state?.name || "",
          vendorType: location?.state?.vendorType || "candle",
          color: location?.state?.color || "",
          showInHomePage: location?.state?.showInHomePage || "false",
          isMain: location?.state?.isMain || "false",
          status:
            location?.state?.status ||
            utils?.CATEGORY_STATUS_VALUES[0]?.value ||
            "",
        }}
        validationSchema={categoryValidation}
        onSubmit={formHandler}
      >
        {(formik) => (
          <Form>
            <div className="mt-6">
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <Input name="name" placeholder="نام" label="نام" type="text" />

                <VendorCategoriesSelect
                  label={"دسته بندی والد"}
                  oldCategory={location?.state?.parents}
                  ref={categoryRef}
                  placeholder="انتخاب دسته‌بندی"
                  onChange={setParents}
                />

                <Input
                  name="color"
                  placeholder="انتخاب رنگ"
                  label="انتخاب رنگ"
                  type="color"
                />
                <Field
                  as="select"
                  name="showInHomePage"
                  label="نمایش در سایت"
                  component={Select}
                >
                  <option value={"true"}>بله</option>;
                  <option value={"false"}>خیر</option>;
                </Field>

                <Field
                  as="select"
                  name="isMain"
                  label="نمایش در منو"
                  component={Select}
                >
                  <option value={"true"}>بله</option>;
                  <option value={"false"}>خیر</option>;
                </Field>

                {utils ? (
                  <Field
                    as="select"
                    name="status"
                    label="وضعیت"
                    component={Select}
                  >
                    {utils?.CATEGORY_STATUS_VALUES.map((item) => {
                      return <option value={item.value}>{item?.name}</option>;
                    })}
                  </Field>
                ) : null}
                <Field
                  as="select"
                  name="vendorType"
                  label="نوع غرفه"
                  component={Select}
                >
                  {utils?.VENDOR_TYPE_VALUES?.length
                    ? utils?.VENDOR_TYPE_VALUES.map((item) => {
                        return (
                          <option value={item?.value}>{item?.name}</option>
                        );
                      })
                    : null}
                </Field>
                <div className="">
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    عکس
                  </label>
                  <div className="flex flex-wrap items-center justify-between gap-3">
                    <div className="flex flex-wrap items-center gap-2 min-w-0">
                      {image ? (
                        <img
                          {...publicImageProps(image, { variant: "thumb_" })}
                          className="w-20 h-20 shrink-0 rounded-xl border border-gray-200 object-contain bg-gray-50 dark:border-gray-700 dark:bg-gray-800"
                          alt=""
                        />
                      ) : (
                        <p className="text-sm">هنوز تصویری انتخاب نشده است.</p>
                      )}
                      {/* <p className="max-w-12 overflow-hidden">{image || ""}</p> */}
                    </div>
                    <div className="flex flex-wrap items-center gap-2 min-w-0">
                      {image && (
                        <Button
                          type="button"
                          onClick={() => setImage("")}
                          text={"حذف"}
                          color={"danger"}
                        />
                      )}

                      <Button
                        type="button"
                        onClick={() => imagesModal.current.showModal()}
                        text={image ? "ویرایش" : "انتخاب"}
                        color={"success"}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-y-2">
                <div className="admin-form-actions">
                  <Button disabled={formik.isSubmitting} loading={formik.isSubmitting}
                    text={location?.state ? "ویرایش" : "افزودن"}
                    type="submit" color="success"
                  />
                  <button type="button" className="admin-form-cancel" onClick={() => navigate("/vendor-store-category-list")}>انصراف</button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
      <ImagesModal selectedImages={selectedImages} ref={imagesModal} />
    </AdminFormLayout>
  );
}
